import React, { useState } from "react"
import {Bar} from 'react-chartjs-2'
import CurrentPost from "./currentPost"
import FanNo1 from "./fanNo1"
import Followers from "./following"
import FriendNo1 from "./friendNo1"
import styles from './main.module.css'
import Overview from "./overview"


const state = {


    labels: ['January', 'February', 'March',
             'April', 'May'],
    datasets: [

      {
        label: 'Rainfall',
        backgroundColor: 'red',
        borderColor: 'red',
        borderWidth: 0,
        color:"red",
        data: [6, 59, 50, 31, 56],
      }
    ]
  }



const Stats =()=>{
  const [con,setCon] = useState("ov");

const highlight ={
  color:"#7124BD",
  fontWeight:"500"
}

    return(
      <div className={styles.container}>
        <div className={styles.nav}>
          <div onClick={()=>setCon("ov")} style={con==="ov"?highlight:{}} >Overview</div>
          <div onClick={()=>setCon("p")} style={con==="p"?highlight:{}} >Post</div>
          <div  onClick={()=>setCon("fanno1")} style={con==="fanno1"?highlight:{}} >Die-hard</div>
          <div  onClick={()=>setCon("friendno1")} style={con==="friendno1"?highlight:{}}>Bosom buddy</div>
          <div   onClick={()=>setCon("followers")} style={con==="folloers"?highlight:{}}>Followers</div>
                  
        </div>
        {con==="ov"?<Overview/>:""}
        {con==="p"?<CurrentPost/>:""}
        {con==="fanno1"?<FanNo1/>:""}
        {con==="friendno1"?<FriendNo1/>:""}
        {con==="followers"?<Followers/>:""}
        
        </div>

    )
}

export default Stats